<script>
import customerDetial from './customer-detial.vue';
import {deleteCustom, getCustomList, updateCustomerStatus} from '@/api/customer'
import raSimpleDialog from "@/components/ra-simple-dialog.vue";
export default {
  name: 'customersIndex',
  components: {
    raSimpleDialog,
    customerDetial
  },
  data() {
    return {
      // 修改后的变量声明
      customerSearchFields: [
        {
          type: 'selectInput',
          prop: 'search_value',
          label: '',
          selectKey: 'search_key',
          placeholder: 'Search..',
          width: '90',
          options: [
            { label: 'Name', value: 'name' },
            { label: 'Cellphone', value: 'phone' },
            { label: 'Invitation Code', value: 'invitation_code' },
          ]
        }
      ],
      baseUrl: process.env.VUE_APP_BASE_URL,
      customerTableData: [],
      customerColumns: [ // 表格列配置
        {label: 'Points', prop: 'points'},
        {label: 'Coupon', prop: 'coupon'},
        {label: 'Invited friends', prop: 'invited_friends'},
        {label: 'Shipped', prop: 'shipped'},
      ],
      searchParams: {},
      page: 1, // 当前页码
      customerTotal: 0, // 数据总数
      activeTabName: 'customerRedemption', // 活动标签页名称
      customerDetialData:{},
      editRow: {},
      accessTitle: 'Deactivate this user',
      accessDesc: '',
      customerLoading:true,
    };
  },
  mounted() {
    this.getTableData({})
  },
  methods: {
    getTableData() {
      this.customerLoading = true
      console.log('ddddd')
      const searchData = {...this.searchParams, limit: 10, page: this.page };
      getCustomList(searchData).then(res => {
        this.customerLoading = false
        if (res.code === 200) {
          this.customerTableData = res.data.list;
          this.customerTotal = res.data.total;
        }
      })
    },
    clearSearchHandle(param) {
      this.page = 1;
      this.searchParams = param;
      this.getTableData()
    },
    // 修改后的函数声明
    customerSearchHandler(searchParams) {
      this.searchParams = searchParams;
      this.getTableData();
    },
    customerPageHandler(page) {
      // 分页处理逻辑
      this.page = page;
      this.customerSearchHandler(this.searchParams);
    },
    customerDeleteHandler(row) {
      this.editRow = row;
      this.$refs.deleteDialog.dialogVisible = true;
    },
    tableClickHandler(row, prop) {
      console.log(row,prop,'ddddd')
      if (prop == 'shipped'){
        this.$router.push({
          path: '/orders',
          query: {
            userName: row.id // 参数
          }
        });
      }else{
        this.customerDetialData = row
        this.$refs.customerDetial.customerDetailDialog = true
        this.$refs.customerDetial.customerActiveNames = prop
      }
    },
    updateListHandle() {
      this.getTableData({})
    },
    openDeleteHandle(val){
      if (val == 'Delete'){
        this.$refs.deleteDialog.dialogVisible = true;
      }else {
        if (this.customerDetialData.is_active === 1) {
          this.accessTitle = 'Deactivate this user'
          this.accessDesc = 'Will you deactivate this user? The user cannot access to Rapidi until his (her) account is activated again.';
        }
        if (this.customerDetialData.is_active === 0) {
          this.accessTitle = 'Activate this user'
          this.accessDesc = 'Will you active this user? The user can access to Rapidi until his (her) account is deactivated again.';
        }
        this.editRow = this.customerDetialData;
         this.$refs.accessDialog.dialogVisible = true;
      }
    },
    deleteHandle() {
      deleteCustom({id: this.editRow.id}).then(res => {
        if (res.code === 200) {
          this.$message.success('delete successfully');
          this.$refs.deleteDialog.dialogVisible = false;
          this.page = 1
          this.getTableData()
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    customerActiveHandler(row) {
      this.$refs.accessDialog.dialogVisible = true;
      this.editRow = row;
      if (row.is_active === 1) {
        this.accessTitle = 'Deactivate this user'
        this.accessDesc = 'Will you deactivate this user? The user cannot access to Rapidi until his (her) account is activated again.';
      }
      if (row.is_active === 0) {
        this.accessTitle = 'Activate this user'
        this.accessDesc = 'Will you active this user? The user can access to Rapidi until his (her) account is deactivated again.';
      }
    },
    accessHandle() {
      // 激活或禁用操作逻辑
      const param = {
        id: this.editRow.id,
        is_active: null,
      }
      if (this.editRow.is_active === 1) {
        param.is_active = 0;
      } else if (this.editRow.is_active === 0) {
        param.is_active = 1;
      }
      updateCustomerStatus(param).then(res => {
        if (res.code === 200) {
          this.$message.success('update successfully');
          this.getTableData()
          this.$refs.customerDetial.customerDetailDialog = false;
          this.$refs.accessDialog.dialogVisible = false;
        } else {
          this.$message.error(res.msg);
        }
      })
    },
  },
};
</script>

<template>
  <div>
    <ra-search-box
      :search-fields="customerSearchFields"
      @search="customerSearchHandler"
      @clear="clearSearchHandle"
    ></ra-search-box>
    <div class="mt-4" v-loading="customerLoading">
      <el-table
        v-if="customerTableData.length"
        :data="customerTableData"
      >
        <el-table-column
          width="55">
          <template slot-scope="scope">
            <div v-if="scope.row.is_active == 1">
              <img class="w-4" src="../../assets/activate.png" alt="">
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="User's name">
          <template slot-scope="scope">
            <div style="cursor: pointer" @click="tableClickHandler(scope.row, 'name')">
              <img class="w-[40px] h-[40px] rounded-full mr-4" :src="baseUrl + scope.row.avatar" alt="">
              <span>{{scope.row.name}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Cellphone No."
          prop="cellphone"
        >
        </el-table-column>
        <el-table-column
          align="center"
          v-for="(columnItem, columnIndex) in customerColumns"
          :label="columnItem.label"
          :prop="columnItem.prop"
          :key="columnIndex"
          :width="columnItem.minWidth"
        >
          <template slot-scope="scope">
            <template>
              <div>
                <div style="margin: 0 auto;text-decoration: underline;cursor: pointer;">
                  <span @click="tableClickHandler(scope.row, columnItem.prop)" >
                     {{scope.row[columnItem.prop]}}
                  </span>
                </div>
              </div>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          width="130"
          align="center"
          header-align="center"
          label="Action"
          v-if="activeTabName === 'customerRedemption'"
        >
          <template slot-scope="scope">
            <div class="customer-action">
              <span v-if="scope.row.is_active === 0" class="cursor-pointer" @click="customerActiveHandler(scope.row)">
                <img src="../../assets/zipCode/ban@2x.png" class="w-4 mr-4" alt="">
              </span>
              <span v-if="scope.row.is_active === 1" @click="customerActiveHandler(scope.row)" class="cursor-pointer">
                  <img src="../../assets/zipCode/activate@2x.png" class="w-4 mr-4" alt="">
              </span>
              <span @click="customerDeleteHandler(scope.row)" class="cursor-pointer">
                <img src="../../assets/zipCode/delete@2x.png" class="w-4 mr-4" alt="">
              </span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <table-empty v-else></table-empty>
      <ra-pagination
        :currentPage="page"
        :list-length="customerTableData.length"
        @pageChange="customerPageHandler"
        :total="customerTotal"
      ></ra-pagination>
    </div>
<!--    详情-->
    <customer-detial
        @updateList="updateListHandle"
        @openDeleteHandle="openDeleteHandle"
        :detail="customerDetialData" ref="customerDetial"/>
    <ra-simple-dialog
        ref="deleteDialog"
        confirm-btn-text="Yes"
        cancel-btn-text="No"
        title="Delete this user"
        @confirmSubmit="deleteHandle"
    >
      <span>Will you delete this user?  The user cannot access to Rapidi anymore.</span>
    </ra-simple-dialog>
    <ra-simple-dialog
        ref="accessDialog"
        confirm-btn-text="Yes"
        cancel-btn-text="No"
        :title="accessTitle"
        @confirmSubmit="accessHandle"
    >
      <span>{{accessDesc}}</span>
    </ra-simple-dialog>
  </div>
</template>

<style scoped lang="less">
</style>
